export default __webpack_public_path__ + "static/media/Logo-White-500.12065923.png";